<template>
  <div class="compound public-content">
    <div class="breadcrumb">线上产品管理</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 10px 0 0">产品库:</span>
        <el-input v-model="searchTagsVo.tagsName" placeholder="请输入产品库"></el-input>
        <span style="margin:0 10px 0 15px">平台类型:</span>
        <el-select v-model="searchTagsVo.storeTypeId" clearable placeholder="请选择">
          <el-option v-for="item in storeTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <el-button round @click="queryInfo.pageNum = 1, onSubmit()">查询</el-button>
        <el-button round @click="isEdit = false, addDialog = true" type="primary">新建产品库</el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="产品库" prop="tagsName"></el-table-column>
          <el-table-column label="平台类型" prop="storeTypeId">
            <template slot-scope="scope">{{ storeTypeObj[scope.row.storeTypeId] }}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" @click="isEdit = true, tagsVo = JSON.parse(JSON.stringify(scope.row)), addDialog = true">编辑 </span>
              <span class="color-blue" @click="$refs.Class.show(scope.row.tagsId)"> 类结构 </span>
              <span class="color-blue" @click="$refs.Product.show(scope.row.tagsId, storeTypeObj[scope.row.storeTypeId])"> 产品 </span>
              <span class="color-blue" @click="deleteId = scope.row.tagsId, deleteDialog = true"> 删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="isEdit ? '编辑产品库' : '新建产品库'" :visible.sync="addDialog" width="500px" @closed='closed'>
      <el-form ref="add" :model="tagsVo" :rules="addRules" label-width="100px">
        <el-form-item label="产品库名称" prop="tagsName">
          <el-input v-model="tagsVo.tagsName"></el-input>
        </el-form-item>
        <el-form-item label="平台类型" prop="storeTypeId">
          <el-select v-model="tagsVo.storeTypeId" :disabled="isEdit" clearable placeholder="请选择">
            <el-option v-for="item in storeTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="add()">确 定</el-button>
      </span>
    </el-dialog>
    <Class ref="Class"></Class>
    <Product ref="Product"></Product>
    <!-- 分页 -->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该产品库？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="del(deleteId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Class from './ClassDialog/index.vue'
import Product from './ProductDialog/index.vue'
import VPagination from '@/components/Pagination/index'
import { posTagsGetTagsList, posTagsDelete, posTagsAdd, posTagsUpdate } from '@/api/pms'
import { storeTypeGetStoreTypeList } from '@/api/crm'
export default {
  name: 'compound',
  components: {
    VPagination, Class, Product
  },
  data () {
    return {
      isEdit: false,
      addRules: {
        tagsName: [
          { required: true, message: '请输入产品库名称', trigger: 'blur' }
        ],
        storeTypeId: [
          { required: true, message: '请选择平台类型', trigger: 'change' }
        ]
      },
      tagsVo: {
        storeTypeId: '',
        tagsName: ''
      },
      addDialog: false,
      storeTypeList: [],
      storeTypeObj: [],
      searchTagsVo: {
        page: 1,
        storeTypeId: '',
        tagsName: ''
      },
      deleteId: '',
      deleteDialog: false,
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      rulesVO: {
        skuName: '',
        spuName: ''
      }
    }
  },
  created () {
    this.getStoreTypeList()
  },
  methods: {
    closed () {
      this.tagsVo = {
        storeTypeId: '',
        tagsName: ''
      }
      this.$refs.add.resetFields()
    },
    add () {
      this.$refs.add.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.isEdit) {
          posTagsUpdate(this.tagsVo)
            .then(res => {
              if (res.data.success) {
                this.$message.success('编辑成功')
                this.$refs.add.resetFields()
                this.addDialog = false
                this.onSubmit()
              }
            })
        } else {
          posTagsAdd(this.tagsVo)
            .then(res => {
              if (res.data.success) {
                this.$message.success('添加成功')
                this.$refs.add.resetFields()
                this.addDialog = false
                this.onSubmit()
              }
            })
        }
      })
    },
    getStoreTypeList () {
      storeTypeGetStoreTypeList()
        .then(res => {
          if (res.data.success) {
            this.storeTypeList = res.data.data
            this.storeTypeObj = res.data.data.reduce((obj, item) => {
              obj[item.id] = item.name
              return obj
            }, {})
            this.onSubmit()
          }
        })
    },
    del (id) {
      posTagsDelete(id)
        .then(res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.onSubmit()
            this.deleteDialog = false
          }
        })
    },
    edit (scope) {
      this.$router.push({
        path: '/MoneyOffNew',
        query: {
          id: scope.row.id
        }
      })
    },
    onSubmit () {
      posTagsGetTagsList({
        pageNum: this.queryInfo.pageNum,
        pageSize: this.queryInfo.pageSize,
        data: this.searchTagsVo
      })
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.records
            this.queryInfo.total = res.data.data.total
          }
        })
    },

    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
 <style scoped lang="less">
 .compound {
   .add-category {
     justify-content: space-between;
   }
 
   .keywords {
     display: flex;
     justify-content: space-around;
     // width: 750px;
     align-items: center;
 
     .el-input {
       width: 180px;
     }
   }
 }
 </style>
